import { Box, styled } from "@mui/material";
import { Button, IconButton, Typography } from "@pmag/ui-components";

export const ControlPanelContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
}));

export const TopContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    gap: theme.spacing(4),

    [theme.breakpoints.down("sm")]: {
        gap: theme.spacing(2),
    },
}));

export const ContentSwitcher = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    border: `1px solid ${theme.palette.core.grey._80}`,
    borderRadius: theme.shape.borderRadius,
}));

export const ComponentSelectButton = styled(Button)(({ theme }) => ({
    flex: 1,
    justifyContent: "center",
    border: "unset",
    borderRadius: "unset",
    borderLeft: `1px solid ${theme.palette.core.grey._80}`,
    borderRight: `1px solid ${theme.palette.core.grey._80}`,
}));

export const ComponentSelectButtonTitle = styled(Typography)(({ theme }) => ({
    color: "inherit",
    [theme.breakpoints.down("md")]: {
        "&, & span": {
            maxWidth: `calc(100vw - 270px)`,
            textOverflow: "ellipsis",
            overflowX: "hidden",
        },
    },
}));

export const StyledBox = styled(Box)(() => ({
    "& .MuiAutocomplete-root": {
        height: "unset",
    },
    "& .MuiAutocomplete-popper": {
        transform: "translate3d(0px, 56px, 0px) !important",
    },
}));

export const IconButtonStyled = styled(IconButton)(({ theme }) => ({
    width: 48,
    border: "unset",
    borderRadius: "unset",
    [theme.breakpoints.down("md")]: {
        width: 32,
    },
}));

export const GroupHeaderBox = styled(Box)(({ theme }) => ({
    background: theme.palette.core.white,
    position: "sticky",
    padding: theme.spacing(2, 3),
    opacity: 1,
    zIndex: 1,
    top: "-10px",
}));

export const GroupItems = styled("ul")(({ theme }) => ({
    padding: `0 0 0 ${theme.spacing(1)}`,
}));

export const SmallRowContainer = styled(Box)(({ theme }) => ({
    display: "none",
    [theme.breakpoints.down("md")]: {
        paddingTop: theme.spacing(4),
        display: "flex",
        flex: 1,
        justifyContent: "space-between",
    },
}));
